module.exports = __webpack_public_path__ + "img/babybook-chevron-purple.e0209f37.svg";